import { MyConversationsInboxType } from '@kamernet/core/ApiClient/Kamernet';
import { parseRouteParamToInt } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

import { INBOX_TYPE_TO_STRING, STRING_TO_INBOX_TYPE } from './MyConversations';

export type ConversationRouteParams = {
  inboxType: MyConversationsInboxType;
  conversationID: number;
  fromListingID?: number | null;
};

export type ConversationRouteParamsString = {
  inboxType: string;
  conversationID: string;
  fromListingID?: string;
};

export const Conversation = defineRoute<
  ConversationRouteParams,
  ConversationRouteParamsString
>({
  pathname: '/my-messages/[inboxType]/conversation/[conversationID]',
  nlPathname: '/mijn-berichten/[inboxType]/conversaties/[conversationID]',
  options: { isLandlordRoute: false, isPublic: false },
  routeParamsStringifier: routeParams => {
    return {
      inboxType: INBOX_TYPE_TO_STRING[routeParams.inboxType],
      conversationID: routeParams.conversationID.toString(),
      fromListingID: routeParams.fromListingID?.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      inboxType:
        STRING_TO_INBOX_TYPE[routeParamsString.inboxType.toLowerCase()] ??
        MyConversationsInboxType.Default,
      conversationID:
        parseRouteParamToInt(routeParamsString.conversationID) || 0,
      fromListingID: parseRouteParamToInt(routeParamsString.fromListingID) || 0,
    };
  },
});
